import React from "react";
import { ChevronRight } from "lucide-react";

export function ContactRow({ finding, onPrune, onView, isPruning }) {
    const c = finding.contact;
    const sev = finding.severity;
    const pillClass = sev === "RED" ? "pill-red" : sev === "YELLOW" ? "pill-yellow" : "pill-green";
    const label = sev === "RED" ? "GHOST" : sev === "YELLOW" ? "STALE" : "VERIFIED";
    return (
        <div className="dendros-card p-3 group" data-testid={`contact-row-${c.id}`}>
            <div className="flex items-start gap-3">
                <div
                    className="w-10 h-10 flex-shrink-0 bg-zinc-800 border border-white/10 rounded-md flex items-center justify-center font-mono text-[11px] text-[#10b981]"
                    aria-hidden
                >
                    {c.avatar_seed || c.name.split(" ").map((p) => p[0]).slice(0, 2).join("")}
                </div>
                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                        <div className="font-body font-semibold text-sm text-white truncate">{c.name}</div>
                        <span
                            className={`font-mono text-[10px] uppercase tracking-wider px-2 py-[2px] ${pillClass}`}
                            data-testid={`contact-status-${c.id}`}
                        >
                            {label}
                        </span>
                    </div>
                    <div className="font-body text-xs text-zinc-400 mt-0.5 truncate">{c.title}</div>
                    {finding.reason && (
                        <div className="font-mono text-[10px] text-zinc-500 mt-2 leading-relaxed">{finding.reason}</div>
                    )}
                    {(sev === "RED" || sev === "YELLOW") && onPrune && (
                        <div className="flex items-center gap-2 mt-3">
                            <button
                                className="btn-danger-d"
                                onClick={() => onPrune(c)}
                                disabled={isPruning}
                                data-testid={`prune-btn-${c.id}`}
                            >
                                {isPruning ? "Removing…" : "Remove"}
                            </button>
                            {onView && (
                                <button
                                    className="btn-ghost-mini inline-flex items-center gap-1"
                                    onClick={() => onView(c)}
                                    data-testid={`view-btn-${c.id}`}
                                >
                                    Trace <ChevronRight size={12} />
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
